import './ProductCard.css';

interface ProductCardProps {
  product: Product;
  isActive: boolean;
  onClick: (val: Product) => void;
}

export interface Product {
  name: string;
  thumbnail: string;
  code: string;
}

export default function ProductCard({
  product,
  isActive,
  onClick,
}: ProductCardProps) {
  return (
    <button
      className={`product-card ${isActive ? 'active' : ''}`}
      onClick={() => onClick(product)}
    >
      <img src={product.thumbnail} alt={product.name} />
      <span>{product.name}</span>
    </button>
  );
}
